import { AxiosPromise, AxiosStatic } from "axios";
import { TNotificationOpenedPayload } from "../types";

const postNotificationOpened =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (payload: TNotificationOpenedPayload): AxiosPromise<void> =>
    await appAxios.post(`${serverURL}/notifications/opened`, payload, {
      withCredentials: true,
    });

export default postNotificationOpened;
